import { createReducer } from "@reduxjs/toolkit";
import { studentRetrievePendingObjectiveAssignments } from "./retrieve-pending-objective-assignments";
import type { PendingObjectiveAssignmentGroupVM } from "@shared-kernel/application/ports/student/student-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<PendingObjectiveAssignmentGroupVM[]> = {
  fetching: "idle",
  data: [],
};

export const pendingObjectiveAssignmentsRetrievalReducer = createReducer<RetrievalState<PendingObjectiveAssignmentGroupVM[]>>(
  initialState,
  builder => {
    builder.addCase(studentRetrievePendingObjectiveAssignments.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(studentRetrievePendingObjectiveAssignments.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(studentRetrievePendingObjectiveAssignments.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
  },
);
